module.exports = {
  methods: {
    humanizeNumber(number) {
      return Math.ceil(number || 0).toLocaleString().replace(/,/g, ' ');
    },
  },
};
